<template>
  <section class="companies">
    <div class="main-header no-border">
      <div class="main-header-left">
        <h3>Companies</h3>
      </div>
      <div class="main-header-right"></div>
    </div>

    <search-bar
        :hidden="false"
        v-model="params.query"
        v-on:search="onSearch"
        placeholder="Search for company"></search-bar>

    <advanced-search
        v-model="params.advanced"
        v-on:search="onAdvancedSearch"></advanced-search>

    <vue-table
        :columns="columns"
        :rows="rows"
        :total-rows="totalRows"
        :database-total="databaseTotal"
        :per-page="params.perPage"
        :current-page="params.page"
        v-on:selected-row="onSelectRow"
        v-on:selected-page="onSelectPage"
        v-on:change-sort="onChangeSort">
      <div class="flex flex-col lg:flex-row space-y-2 lg:space-y-0" slot="options">
        <div class="flex-grow mb-2"></div>
        <div class="text-right inline-flex items-center space-x-2">
          <icon-button id="download_csv" uppercase @click.native="downloadCsv()" v-if="allowDownload">
            <slot slot="icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="fill-white">
                <path
                    d="M384 128h-128V0L384 128zM256 160H384v304c0 26.51-21.49 48-48 48h-288C21.49 512 0 490.5 0 464v-416C0 21.49 21.49 0 48 0H224l.0039 128C224 145.7 238.3 160 256 160zM255 295L216 334.1V232c0-13.25-10.75-24-24-24S168 218.8 168 232v102.1L128.1 295C124.3 290.3 118.2 288 112 288S99.72 290.3 95.03 295c-9.375 9.375-9.375 24.56 0 33.94l80 80c9.375 9.375 24.56 9.375 33.94 0l80-80c9.375-9.375 9.375-24.56 0-33.94S264.4 285.7 255 295z"/>
              </svg>
            </slot>
            <slot slot="label">Download CSV</slot>
          </icon-button>
        </div>
      </div>
    </vue-table>
  </section>
</template>

<script>
import VueTable from '../VueTable.vue';
import VueButton from '../VueButton.vue';
import VueModal from '../VueModal.vue';
import StatusBlock from '../StatusBlock.vue';
import SearchBar from '../SearchBar.vue';
import WebServices from '../../../services/WebServices';
import Parameters from '../../../mixins/Parameters';
import Format from '../../../mixins/Format';
import AdvancedSearch from './AdvancedCompanySearch.vue';
import IconButton from "../IconButton.vue";
import Vue from 'vue/dist/vue'

export default {

  mixins: [ Parameters, Format ],

  components: {IconButton, VueTable, VueButton, VueModal, StatusBlock, SearchBar, AdvancedSearch },

  data () {
    return {
      companyServices: WebServices("Companies"),
      columns: {
        name: {
          title: "Name"
        },
        url: {
          title: 'Website',
          transform: function(value) {
            return value !== null && value.length > 0 ? `<a href="${value}">${value}</a>` : '';
          }
        },
        types: {
          title: "Company Type",
          sortable: false,
          transform: function(value) { return value.map(function(itm) { return itm.name }).join(", ") }
        },
        created_at: {
          title: "Entered",
          transform: function(value) { return this.utcToLocal(value, "MM/DD/YY") }.bind(this)
        },
        updated_at: {
          title: "Updated",
          transform: function(value) { return this.utcToLocal(value, "MM/DD/YY") }.bind(this)
        }
      },
      rows: null,
      params: {
        query: "",
        page: 1,
        perPage: 15,
        orderBy: null,
        orderDirection: null,
        advanced: {}
      },
      totalRows: 0,
      databaseTotal: 0,
      allowDownload: this.$root.$data.auth.user.allowDownload,
    }
  },

  created () {
    this.loadInitial();
  },

  methods: {

    loadInitial () {
      this.params = this.getParameters();
      this.params.mine = this.$route.name.indexOf("companies.mine") === 0;
      if (this.$route.params.tagId) {
        this.params.tag = parseInt(this.$route.params.tagId || 0);
      }
      this.getAll()
    },

    getAll () {
      this.companyServices
          .getAll(this.params)
          .then(function(response) {
            var properties = response.data.data;
            this.totalRows = properties.total;
            this.databaseTotal = response.data.total;
            this.rows = properties.data;
          }.bind(this));
    },

    onSearch (query) {
      this.params.query = query;
      this.params.page = 1;
      this.setParameters(this.params);
    },

    onAdvancedSearch () {
      var jsonString = JSON.stringify(this.params.advanced);
      if (jsonString.indexOf("%") >= 0) {
        var newJson = decodeURIComponent(jsonString.toString());
        newJson = newJson.substr(1);
        newJson = newJson.substr(0, newJson.length - 1)
        newJson = JSON.parse(newJson);
        this.params.advanced = newJson;
      }
      this.params.page = 1;
      this.setParameters(this.params);
    },

    onSelectRow (row) {
      this.$router.push({ name: 'companies.show', params : { companyId: row.id, row: row } });
    },

    onChangeSort (sort) {
      this.params.orderBy = sort.column;
      this.params.orderDirection = sort.direction;
      this.setParameters(this.params);
    },

    onSelectPage (page) {
      this.params.page = page;
      this.setParameters(this.params);
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },

    downloadCsv() {
      // needs to toggle url.
      this.postParameters(Vue.baseUrl + '/Companies/Download', this.params, this.$root.$data.auth.getToken());
    },

  },

  watch: {
    '$root.$data.auth.user': {
      handler: function () {
        this.tags = this.$root.$data.auth.user.projectTags;
        this.allowDownload = this.$root.$data.auth.user.allowDownload;
      },
      deep: true
    },
    '$route': function() {
      this.loadInitial();
    }
  },
}

</script>

<style>
.companies {
  position: relative;
}

section.companies.hide-new tr.table-tr {
  opacity: 1;
}

section.companies.hide-new tr.table-tr.new-project {
  opacity: 0.45;
}

section.companies.hide-updated tr.table-tr {
  opacity: 0.45;
}

section.companies.hide-updated tr.table-tr.new-project {
  opacity: 1;
}

</style>
